// Calls to the Ask HR API with the signed-in user's token. See response.ts for how replies and
// refusals are read.

import { apiToken } from "./auth/msal.js";
import { readResponse } from "./response.js";

export { ApiError } from "./response.js";

export async function api<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: {
      authorization: `Bearer ${await apiToken()}`,
      ...(body === undefined ? {} : { "content-type": "application/json" }),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  return (await readResponse(res)) as T;
}
